import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getModel } from '../selectors';
import * as actions from '../actions';
import SingleDriveComponent from './SingleDriveComponent';

const SingleDriveContainer = (props) => {
    return <SingleDriveComponent {...props} />;
};

const mapStateToProps = (state) => {
    const model = getModel(state);
    return {
        model
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
};

const SingleDriveContainerConn = connect(
    mapStateToProps,
    mapDispatchToProps
)(SingleDriveContainer);

export default React.memo(SingleDriveContainerConn);
